define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var i18n = require('i18n');
    var unicode = require('util/unicode.util');
    var mathUtil = require('util/math.util');
    var alphaReSrc = unicode.alphabeticRe.source.split('[');
    var rePlaceholder = '___placeholder___';
    var alphaReTmpl = '^' + alphaReSrc[0] + '[' + rePlaceholder + alphaReSrc.slice(1).join('[') + '+$';

    // MCBB-604: in ios12 on mobile devices when user tap apostrophe on a keyboard after a word a (’) (U+2019)
    // `right single quotation mark` symbol is produced instead. This is syntactically incorrect, since this symbol
    // is actually a quotation mark that should be used to denote a quote and it should have an opening left quote.
    // In ios, however, it's used as apostrophe by default.
    // Considering all above - there's no single unicode subrange to include this symbol, so we just hardcode it.
    var firstLastNameRe = new RegExp('^(?! )' + alphaReTmpl.replace(rePlaceholder, ',.\'’\\-\\s'));
    var postcodeRe = new RegExp('^(?! )' + alphaReTmpl.replace(rePlaceholder, '\\s\\d_\\-/#\\\\'));
    var addressRe = new RegExp('^(?! )' + alphaReTmpl.replace(rePlaceholder, '.,#&_/\'’\\-\\d\\s\\\\'));
    var cityRe = new RegExp('^(?! )' + alphaReTmpl.replace(rePlaceholder, '\\d\\-.,\'’\\s'));
    var stateRe = new RegExp('^(?! )' + alphaReTmpl.replace(rePlaceholder, '\\-.,\\s'));
    const moneyRegex = /^((\d+[.,]?\d{0,2}$)|([.,]\d{1,2}$))/;

    var addressLookupSwissValidateFn = function($inputs, c, form) {
        const input = $inputs[0];
        const dataset = input.dataset;
        const controlType = dataset.controlType;
        const customControl = _.findWhere(form._customControls, _.pick(dataset, 'id'));
        const defaultErrorMessage = 'playtech.mobile.registration.addressLookupSwiss.required';
        const innerFields = controlType === 'streetName' || controlType === 'houseNumber'
            ? [controlType]
            : ['zip', 'city', 'streetName', 'houseNumber'];

        const isEmptySomeRequired = innerFields.some((fieldName) =>
            'required' in form.options.validationConfig[fieldName] && !form.data()[fieldName]
        );

        const controlValidationRules = controlType === 'zipCity'
            ? customControl.options.validationRules
            : form.options.validationConfig[controlType];

        const errorMessage = _.property('message')(
            _.findWhere(controlValidationRules, { type: 'required' })
        );

        if (isEmptySomeRequired) {
            this.message = i18n.t(errorMessage || defaultErrorMessage);
            return false;
        }

        return true;
    };

    var addressLookupValidateFn = function($inputs, c, form) {
        var input = $inputs[0];
        var formData = form.data();
        var dataset = input.dataset;
        var customControl = form._customControls.find(ctrl => ctrl.id === dataset.id);

        var isEmptySomeRequired = customControl.options.innerFields.some(field => {
            return 'required' in form.options.validationConfig[field.name] && !formData[field.name];
        });

        if (isEmptySomeRequired) {
            var defaultErrorMessage = 'playtech.mobile.system.user.tooltip.addressLookup.required';
            var controlValidationRules = customControl.options.validationRules;
            var ruleRequired = controlValidationRules.find(rule => rule.type === 'required');

            this.message = i18n.t(ruleRequired?.message || defaultErrorMessage);

            return false;
        }

        return true;
    };

    var checkRomanianID = function($inputs, conf, form, state, event, data) {
        //COR18-63 Romanian regulations
        if (!data.birthdate || !data.sex) {
            this.message = i18n.t('playtech.mobile.system.user.tooltip.romanianID.emptyGenderBirth');
            return false;
        }
        var value = $inputs.val();
        var idSplits = value
            .split(/(\w{1})(\w{6})(\w{2})(\w{3})(\w{1})/)
            .filter(function(portion) {
                return portion !== '';
            });
        var idGenderCentury = idSplits[0];
        var idBirthDate = idSplits[1];
        var idCountryZone = idSplits[2];
        var idSerialNumber = idSplits[3];
        var idCheckSum = idSplits[4];

        var dateSplits = data.birthdate.split('-');
        var year = dateSplits[0];
        var month = dateSplits[1];
        var day = dateSplits[2];

        var male = data.sex === 'M';
        var female = data.sex === 'F';

        var verifyGenderCentury = function() {
            var id = Number(idGenderCentury);
            var y = Number(year);
            if (male && id === 7 || female && id === 8 || id === 9) {
                return true;
            }
            if (y >= 1900 && y <= 1999) {
                return male && id === 1 || female && id === 2;
            }
            if (y >= 1800 && y <= 1899) {
                return male && id === 3 || female && id === 4;
            }
            if (y >= 2000) {
                return male && id === 5 || female && id === 6;
            }
        };
        var verifyBirthDate = function() {
            var dateFormatted = year.slice(-2) + month + day;// format date in YYMMDD'
            return idBirthDate === dateFormatted;
        };
        var verifyCountryZone = function() {
            var id = parseInt(idCountryZone);

            return id === 80 || id === 99 || id >= 1 && id <= 52;
        };
        var verifySerialNumber = function() {
            return idSerialNumber.length === 3;
        };
        var verifyCheckSum = function() {
            var control = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];
            var slicedIdArr = value.slice(0, 12).split('').map(Number);
            var checkSumValue = slicedIdArr.reduce(function(memo, item, index) {
                memo = memo + item * control[index];
                return memo;
            }, 0);

            var reminder = checkSumValue % 11;
            reminder = reminder === 10 ? 1 : reminder;

            return reminder === Number(idCheckSum);
        };

        return verifyGenderCentury()
            && verifyBirthDate()
            && verifyCountryZone()
            && verifySerialNumber()
            && verifyCheckSum();
    };

    var checkPesel = function($inputs, conf, form, state, event, data) {
        // although reg builder won't allow to do this we'll make this fail-proof check
        if (!data.birthdate || !data.sex) {
            return false;
        }

        var pesel = $inputs.val();

        if (!/^\d{11}$/.test(pesel)) {
            return false;
        }

        var peselSplits = pesel
            .split(/(\w{2})(\w{2})(\w{2})(\w{4})(\w)/)
            .filter(function(part) {
                return part !== '';
            })
            .map(function(part) {
                return Number(part);
            });
        var peselRR = peselSplits[0];
        var peselMM = peselSplits[1];
        var peselDD = peselSplits[2];
        var peselPPPP = peselSplits[3];
        var peselK = peselSplits[4];

        var dateSplits = data.birthdate.split('-');
        var year = Number(dateSplits[0]);
        var month = Number(dateSplits[1]);
        var day = Number(dateSplits[2]);

        var checkPeselYear = function() {
            return peselRR === year % 100;
        };

        var checkPeselMonth = function() {
            var shift;

            if (year >= 1900 && year <= 1999) {
                shift = 0;
            } else if (year >= 1800 && year <= 1899) {
                shift = 80;
            } else if (year >= 2000 && year <= 2099) {
                shift = 20;
            } else if (year >= 2100 && year <= 2199) {
                shift = 40;
            } else if (year >= 2200 && year <= 2299) {
                shift = 60;
            }

            return peselMM === month + shift;
        };

        var checkPeselDay = function() {
            return peselDD === day;
        };

        var checkPeselGender = function() {
            var oddity = data.sex === 'M'
                ? 1
                : 0;

            return peselPPPP % 2 === oddity;
        };

        var checkPeselCheckSum = function() {
            var weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
            var checkSum = pesel
                .split('')
                .slice(0, 10)
                .map(function(peselDigit, index) {
                    return Number(peselDigit) * weights[index];
                })
                .reduce(function(result, num) {
                    return result + num;
                }, 0);

            checkSum = (10 - checkSum % 10) % 10;

            return peselK === checkSum;
        };

        return checkPeselYear()
            && checkPeselMonth()
            && checkPeselDay()
            && checkPeselGender()
            && checkPeselCheckSum();
    };

    var checkControlLetter = function(digits, controlLetter) {
        var controlLettersList = 'TRWAGMYFPDXBNJZSQVHLCKE'.split('');

        return controlLettersList[parseInt(digits) % 23] === controlLetter;
    };

    var checkDNI = function(id) {
        var regExp = /^(\d{1,8})([A-Z])$/;

        var isValid = regExp.test(id);
        var match = id.match(regExp);

        return isValid && checkControlLetter(match[1], match[2]);
    };

    var checkNIE = function(id) {
        var prefixList = ['X', 'Y', 'Z'];
        var regExp = /^([XYZ])(\d{7})([A-Z])$/;

        var isValid = regExp.test(id);
        var match = id.match(regExp);

        return isValid && checkControlLetter(prefixList.indexOf(match[1]).toString() + match[2], match[3]);
    };

    var checkNIF = function(nif) {
        if (!['1', '2', '3', '5', '6', '8'].includes(nif.substr(0, 1)) &&
            !['45', '70', '71', '72', '77', '79', '90', '91', '98', '99'].includes(nif.substr(0, 2))) {
            return false;
        }

        var total = nif[0] * 9 + nif[1] * 8 + nif[2] * 7 + nif[3] * 6 + nif[4] * 5 + nif[5] * 4 + nif[6] * 3
            + nif[7] * 2;

        var modulo11 = total - parseInt(total / 11) * 11;
        var comparador = modulo11 === 1 || modulo11 === 0 ? 0 : 11 - modulo11;

        return Number(nif[8]) === comparador;
    };

    var checkSpanishRules = function($inputs, conf, form, state, event, data) {
        if (!(data.countrycode && data.citizenship)) {
            this.message = i18n.t('playtech.mobile.system.user.tooltip.spanishID.emptyCountryOrNational');
            return false;
        }

        var value = $inputs.val().trim();
        var countrycode = data.countrycode;
        var citizenship = data.citizenship;
        var addMissingNumbers = function() {
            var length = value.length;
            var DNIlength = 9;

            if (length < DNIlength) {
                $inputs[0].value = String('00000000' + value).slice(-DNIlength);
            }
        };

        if (citizenship !== 'ES' && countrycode !== 'ES') {
            return true;
        }

        if (citizenship === 'ES') {
            if (countrycode !== 'ES') {
                if (!value.length) {
                    return true;
                }
            }

            if (countrycode === 'ES') {
                if (!value.length) {
                    this.message = i18n.t('playtech.mobile.system.user.tooltip.spanishID.required');
                    return false;
                }
            }

            if (!checkDNI(value)) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.spanishID.wrong', 'DNI');
                return false;
            }

            addMissingNumbers();

            return true;
        }

        if (citizenship !== 'ES' && countrycode === 'ES') {
            if (!value.length) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.spanishID.required');
                return false;
            }

            if (!checkNIE(value)) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.spanishID.wrong', 'NIE');
                return false;
            }

            return true;
        }
    };

    var checkPortugalRules = function($inputs, conf, form, state, event, data) {
        if (!data.citizenship) {
            this.message = i18n.t('playtech.mobile.system.user.tooltip.portugalID.emptyNational');
            return false;
        }

        var value = $inputs.val().trim();
        var isPortugal = data.citizenship === 'PT';

        if (value.length) {
            this.message = i18n.t('playtech.mobile.system.user.tooltip.portugalID.wrong');

            return checkNIF(value);
        }

        this.message = i18n.t('playtech.mobile.system.user.tooltip.portugalID.required');

        return !isPortugal;
    };

    var checkSouthAfricanRules = function($inputs, conf, form, state, event, data) {
        const value = $inputs.val().trim();

        const birthdate = data.birthdate || '';
        const [yyyy, mm, dd] = birthdate.split('-');
        const yy = yyyy.substring(2);
        const dateOfBirthPart = value.substring(0, 6);

        if (dateOfBirthPart !== `${yy}${mm}${dd}`) {
            this.message = i18n.t('playtech.mobile.system.user.tooltip.southafricanid.wrongDateOfBirth');

            return false;
        }

        const actualSum = value.split('').reduceRight((sum, val, i, arr) => {
            const rightToLeftIndex = arr.length - i;
            const multiplier = rightToLeftIndex % 2 ? 1 : 2;
            const add = multiplier * Number(val);

            return sum + (add > 9 ? add - 9 : add);
        }, 0);

        return actualSum % 10 === 0;
    };

    /**
     * The first three consonants of the surname or firstname are used.
     * If the name has less than three consonants, then vowels will replace the blank spaces, in the same order they appear in the name (e.g. "Rossi" would be RSS, "Masi" would be MSA).
     * If the whole name has less than three letters, the blank spaces are replaced with an X (e.g. "Fo" would be FOX, "Hu" would be HUX).
     * If the name has more than three consonants, the 2nd is skipped (e.g. "Riccardo" would be RCR; "Martina" would be MTN).
     * This second-consonant skipping rule for names that have more than three consonants is only used for firstnames, not for surnames.
     * @param name {string}
     * @param shouldSkipSecond {boolean}
     * @return {string}
     */
    var getItalianIdName3LetterCode = function(name, shouldSkipSecond = false) {
        const vowels = ['A', 'E', 'I', 'O', 'U'];

        const chars = name
            .replace(/[^a-z0-9]/gi, '')
            .toUpperCase()
            .split('');

        const nameVowels = chars.filter(c => vowels.includes(c));
        let nameConsonants = chars.filter(c => !vowels.includes(c));

        if (shouldSkipSecond && nameConsonants.length > 3) {
            const [c1, , ...otherNameConsonants] = nameConsonants;

            nameConsonants = [c1, ...otherNameConsonants];
        }

        return [
            ...nameConsonants,
            ...nameVowels,
            ...['X', 'X', 'X']
        ].slice(0, 3).join('');
    };

    /**
     * Get month letter code mapped like:
     * A - January; B - February; C - March;
     * D - April;   E - May;      H - June;
     * L - July;    M - August;   P - September;
     * R - October; S - November; T - December
     * @param mm {string} Month number from "01" to "12"
     * @return {string}
     */
    var getItalianIdMonthLetter = function(mm) {
        const map = ['', 'A', 'B', 'C', 'D', 'E', 'H', 'L', 'M', 'P', 'R', 'S', 'T'];
        const monthNmb = Number(mm);

        return map[monthNmb];
    };

    /**
     * Birthday and gender (2 digits): the two birthday digits are used (from 01 to 31);
     * if the person is a woman, 40 is added (e.g. 01 would be 41, 31 would be 71).
     * @param dd {string} Day from "01" to "31"
     * @param gender {string} "M" or "F"
     * @return {string} from "01" to "31" for Male and "41" to "71" for Female
     */
    var getItalianIdBirthDayWithGenderCode = function(dd, gender) {
        if (gender === 'M' || !dd) {
            return dd;
        }

        return (Number(dd) + 40).toString();
    };

    var getItalianIdCheckSumCharacter = function(code) {
        const chars = code.split('');

        const oddCharsMap = {
            '0': 1, '9': 21, 'I': 19, 'R': 8,
            '1': 0, 'A': 1, 'J': 21, 'S': 12,
            '2': 5, 'B': 0, 'K': 2, 'T': 14,
            '3': 7, 'C': 5, 'L': 4, 'U': 16,
            '4': 9, 'D': 7, 'M': 18, 'V': 10,
            '5': 13, 'E': 9, 'N': 20, 'W': 22,
            '6': 15, 'F': 13, 'O': 11, 'X': 25,
            '7': 17, 'G': 15, 'P': 3, 'Y': 24,
            '8': 19, 'H': 17, 'Q': 6, 'Z': 23
        };
        const evenCharsMap = {
            '0': 0, '9': 9, 'I': 8, 'R': 17,
            '1': 1, 'A': 0, 'J': 9, 'S': 18,
            '2': 2, 'B': 1, 'K': 10, 'T': 19,
            '3': 3, 'C': 2, 'L': 11, 'U': 20,
            '4': 4, 'D': 3, 'M': 12, 'V': 21,
            '5': 5, 'E': 4, 'N': 13, 'W': 22,
            '6': 6, 'F': 5, 'O': 14, 'X': 23,
            '7': 7, 'G': 6, 'P': 15, 'Y': 24,
            '8': 8, 'H': 7, 'Q': 16, 'Z': 25
        };
        const remainderMap = [
            'A', 'B', 'C', 'D', 'E', 'F', 'G',
            'H', 'I', 'J', 'K', 'L', 'M', 'N',
            'O', 'P', 'Q', 'R', 'S', 'T', 'U',
            'V', 'W', 'X', 'Y', 'Z'
        ];

        const sum = chars.reduce((acc, c, index) => {
            const charMaps = (index + 1) % 2 === 0 ? evenCharsMap : oddCharsMap;

            return acc + charMaps[c];
        }, 0);
        const remainder = sum % 26;

        return remainderMap[remainder];
    };

    var italianIdDigitToLetter = function(digit) {
        const digitsMap = ['L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V'];

        return digitsMap[parseInt(digit)];
    };

    var italianIdLetterToDigit = function(char) {
        const isDigit = (c) => !Number.isNaN(parseInt(c));
        const digitsMap = ['L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V'];

        return char
            .split('')
            .map(c => isDigit(c) ? Number(c) : digitsMap.indexOf(c))
            .filter(d => d !== -1)
            .map(d => d.toString())
            .join('');
    };

    /**
     * Compare 2 fiscal codes with taking into account that in cases when two people yield the same code,
     * the fiscal administration replaces some numeric digits (starting from the rightmost one)
     * with letters:
     * | Digit | Letter | Digit | Letter |
     * |   0   |   L    |   5   |   R    |
     * |   1   |   M    |   6   |   S    |
     * |   2   |   N    |   7   |   T    |
     * |   3   |   P    |   8   |   U    |
     * |   4   |   Q    |   9   |   V    |
     * @param code1 {string} 15 character fiscal code
     * @param code2 {string} 15 character fiscal code
     * @return {number[]} indexes where IDs are different
     */
    var compareItalianIDs = function(code1, code2) {
        if (code1?.length !== code2?.length) {
            return [15];
        }

        let diffIndexes = [];
        const isDigit = (c) => !Number.isNaN(parseInt(c));
        const code1Chars = code1.split('');
        const code2Chars = code2.split('');

        code1Chars
            .map((c1, index) => [c1, code2Chars[index]])
            .forEach(([c1, c2], index) => {
                if (c1 === c2) {
                    return;
                }

                if (isDigit(c1) && !isDigit(c2)) {
                    diffIndexes = [...diffIndexes, ...italianIdDigitToLetter(c1) !== c2 && [index] || []];
                } else if (!isDigit(c1) && isDigit(c2)) {
                    diffIndexes = [...diffIndexes, ...c1 !== italianIdDigitToLetter(c2) && [index] || []];
                } else {
                    diffIndexes = [...diffIndexes, index];
                }
            });

        return diffIndexes;
    };

    var checkItalianRules = function($inputs, conf, form, state, event, data) {
        const value = $inputs.val().trim().toUpperCase();
        const inputCode = value.slice(0, 15);
        const inputCodesCheckChar = value.slice(-1);
        const birthDayFromCode = value.slice(9, 11);
        const expectedInputCheckChar = getItalianIdCheckSumCharacter(inputCode);

        const firstname = data.firstname || '';
        const lastname = data.lastname || '';
        const sex = data.sex || '';
        const [countryRegulationCode, countryCode] = (data.countryOfBirth || '').split('-');
        const cityOfBirth = (data.cityOfBirth || '').split('-')[0];
        const birthdate = data.birthdate || '';

        if (inputCodesCheckChar !== expectedInputCheckChar || !/^[A-Z]{6}[A-Z0-9]{2}[A-Z][A-Z0-9]{6}$/.test(inputCode)) {
            return false;
        }

        const [yyyy, mm, dd] = birthdate.split('-');
        const yy = yyyy.substring(2);

        const generatedCode = [
            getItalianIdName3LetterCode(lastname),
            getItalianIdName3LetterCode(firstname, true),
            yy || '__',
            getItalianIdMonthLetter(mm) || '_',
            getItalianIdBirthDayWithGenderCode(dd, sex) || '__',
            (countryCode === 'IT' ? cityOfBirth : countryRegulationCode) || '____'
        ].join('');

        let incorrectFields = [];
        const diffIndexes = compareItalianIDs(inputCode, generatedCode) || [];
        // lastname diff
        if (diffIndexes.includes(0) || diffIndexes.includes(1) || diffIndexes.includes(2)) {
            incorrectFields.push(i18n.t('playtech.mobile.registration.lastName'));
        }
        // firstname diff
        if (diffIndexes.includes(3) || diffIndexes.includes(4) || diffIndexes.includes(5)) {
            incorrectFields.push(i18n.t('playtech.mobile.registration.firstName'));
        }
        // birthdate diff
        if (diffIndexes.includes(6) || diffIndexes.includes(7) || diffIndexes.includes(8)) {
            incorrectFields.push(i18n.t('playtech.mobile.registration.dateOfBirth'));
        }
        // birthdate and/or gender diff
        if (diffIndexes.includes(9) || diffIndexes.includes(10)) {
            const birthDayFromCodeAsNumber = Number(italianIdLetterToDigit(birthDayFromCode));
            const isIncorrectGender = birthDayFromCodeAsNumber > 40 ? sex !== 'F' : sex !== 'M';
            const isIncorrectBirthday = birthDayFromCodeAsNumber > 40
                ? birthDayFromCodeAsNumber - 40 !== Number(dd)
                : birthDayFromCodeAsNumber !== Number(dd);
            isIncorrectGender && incorrectFields.push(i18n.t('playtech.mobile.registration.gender'));
            isIncorrectBirthday && incorrectFields.push(i18n.t('playtech.mobile.registration.dateOfBirth'));
        }
        // country or city diff
        if (diffIndexes.includes(11) || diffIndexes.includes(12) || diffIndexes.includes(13) || diffIndexes.includes(14)) {
            incorrectFields.push(countryCode === 'IT'
                ? i18n.t('playtech.mobile.registration.placeOfBirth.cityOfBirth.label')
                : i18n.t('playtech.mobile.registration.placeOfBirth.countryOfBirth.label')
            );
        }

        incorrectFields = [...new Set(incorrectFields)];

        if (incorrectFields.length) {
            this.message = i18n.t(
                'playtech.mobile.system.user.tooltip.italianID.wrong',
                incorrectFields.join(', ')
            );
        }

        return diffIndexes.length === 0;
    };

    var validateIban = function($inputs, conf, form, state, event, data) {
        this.message = i18n.t('playtech.mobile.registration.iban.error.doubleCheck');
        var value = $inputs.val().trim();

        if (!data.countrycode || !value || !/\d+/.test(value)) {
            return false;
        }

        var countryCodeNum = Array.from(data.countrycode)
            .map(function(char) {
                return char.charCodeAt(0) - 55;
            })
            .join('');

        var ibanMod = value.substring(2) + countryCodeNum + value.substring(0, 2);

        return mathUtil.modulo(ibanMod, 97) === 1;
    };

    var isZeroAndIsInput = function(value, isInputType) {
            var isInvalidValue = !value && value !== 0;
            var isZeroValue = value === 0 && isInputType;
            return !(isInvalidValue || isZeroValue);
        };

    var isZeroAndIsDropdown = function(value, isInputType) {
        return value === 0 && !isInputType;
    };

    var isFitLimitAmount = {
        'session': function(data, isInputType) {
            var value = data.session;
            // deposit limit has editable dropdown type
            // 'isInputType' param use for loss/bet limits
            var isDepositLimit = _.isUndefined(isInputType);

            if (!isDepositLimit && !isZeroAndIsInput(value, isInputType)) {
                return false;
            }
            if (!isDepositLimit && isZeroAndIsDropdown(value, isInputType)) {
                return true;
            }

            if (data.day && data.day < value) {
                return false;
            }
            if (data.week && data.week < value) {
                return false;
            }
            if (data.month && data.month < value) {
                return false;
            }

            return true;
        },
        'day': function(data, isInputType) {
            var value = data.day;

            if (!isZeroAndIsInput(value, isInputType)) {
                return false;
            }
            if (isZeroAndIsDropdown(value, isInputType)) {
                return true;
            }
            if (data.week && data.week < value) {
                return false;
            }
            if (data.month && data.month < value) {
                return false;
            }
            if (data.session && data.session > value) {
                return false;
            }

            return true;
        },
        'week': function(data, isInputType) {
            var value = data.week;

            if (!isZeroAndIsInput(value, isInputType)) {
                return false;
            }
            if (isZeroAndIsDropdown(value, isInputType)) {
                return true;
            }
            if (data.day && data.day > value) {
                return false;
            }
            if (data.month && data.month < value) {
                return false;
            }
            if (data.session && data.session > value) {
                return false;
            }

            return true;
        },
        'month': function(data, isInputType) {
            var value = data.month;

            if (!isZeroAndIsInput(value, isInputType)) {
                return false;
            }
            if (isZeroAndIsDropdown(value, isInputType)) {
                return true;
            }
            if (data.day && data.day > value) {
                return false;
            }
            if (data.week && data.week > value) {
                return false;
            }
            if (data.session && data.session > value) {
                return false;
            }

            return true;
        }
    };

    module.exports = {
        firstLastNameRe,
        postcodeRe,
        addressRe,
        cityRe,
        stateRe,

        addressLookupSwissValidateFn,
        addressLookupValidateFn,

        checkRomanianID,
        checkPesel,
        checkSpanishRules,
        checkPortugalRules,
        checkSouthAfricanRules,
        checkItalianRules,

        validateIban,

        isFitLimitAmount,
        moneyRegex
    };
});
